import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
  state: { // 要设置的全局访问的state 对象
    // 要设置的初始属性值
    count: '',
    client: 0,
    vip_level: 0,
    ChangeShowCom: true,
    // 关闭注册登录界面
    GlobalLogin: null,
    // 关闭微信登录页面
    WXshutDown: null
  },
  getters: {
    getCount (state) {
      return state.count
    },
    isShow (state) {
      return state.ChangeShowCom
    }
  },
  mutations: {
    addCount (state, str) {
      state.count = str
    },
    addNice (state, num) {
      state.client = num
    },
    addVip (state, num) {
      state.vip_level = num
    },
    addGlobalLogin (state, bool) {
      state.GlobalLogin = bool
    },
    // 外部关闭微信扫码
    addWXshutDown (state, bool) {
      state.WXshutDown = bool
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js